// From https://github.com/vercel/next.js/blob/canary/examples/with-google-tag-manager/lib/gtm.js

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, any>[];
};

declare const window: WindowWithDataLayer;

export const GTM_ID = process.env.NEXT_PUBLIC_GTM;

export const pageview = (url: string) => {
  if (typeof window.dataLayer !== 'undefined') {
    const dlObject = window.dataLayer.find((dlObject: any) => dlObject.event === 'pageview' && dlObject.page === url);
    if (!dlObject) {
      window.dataLayer.push({
        event: 'pageview',
        page: url
      });
    }
  } else {
    console.log({
      event: 'pageview',
      page: url
    });
  }
};
